export default __webpack_public_path__ + "static/media/1914.d310400e.png";